import * as S from './PageFormRow.styled';
import { IPageFormRow } from './IPageFormRow';

export const PageFormRow = (props: IPageFormRow): JSX.Element => {
  const { children, width, ...rest } = props;
  return (
    <S.Wrapper width={width} {...rest}>
      {children}
    </S.Wrapper>
  );
};

export default PageFormRow;
